document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-school-group-swatch]');
  if (!swatch) return;

  if (event.defaultPrevented) return;
  if (event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const card = swatch.closest('[data-school-group-card]');
  if (!card) return;

  const targetProductId = swatch.getAttribute('data-target-product-id');
  if (!targetProductId) return;

  const targetPane = card.querySelector(
    `[data-school-group-pane][data-product-id="${CSS.escape(targetProductId)}"]`
  );
  if (!targetPane) return;

  event.preventDefault();

  card.querySelectorAll('[data-school-group-pane]').forEach((pane) => {
    const isActive = pane === targetPane;
    pane.classList.toggle('is-active', isActive);
    pane.hidden = !isActive;
    pane.setAttribute('aria-hidden', String(!isActive));
  });

  card.querySelectorAll('[data-school-group-swatch]').forEach((item) => {
    item.classList.toggle('is-active', item === swatch);
  });
});
